import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.less'],
})
export class TextInputComponent extends CustomFormControl implements OnInit, OnDestroy {
    @Input() type: 'text' | 'password' = 'text';
    @Input() placeholder = '';
    @Input() size: 'large' | 'small' | 'default' = 'default';
    @Input() mask: string;
    @Input() maxlength: number;
    @Input() restrict: RegExp;
    @Input() showMask = false;
    @Input() icon: string;
    @Input() textOnDisabled = false;
    @Input() dropSpecialCharacters = true;
    @Input() uppercase = false;

    subscriptions: Subscription = new Subscription();

    patterns: { [p: string]: { pattern: RegExp, optional?: boolean, symbol?: string } } = undefined;

    ngOnInit(): any {
        if (this.uppercase) {
            this.subscriptions.add(
                this.control.valueChanges
                    .subscribe(value => {
                        this.control.patchValue(value ? value.toUpperCase() : value, {emitEvent: false});
                    })
            );
            if (!this.restrict) {
                this.restrict = new RegExp('.');
            }
        }

        if (this.restrict) {
            if (this.mask) {
                this.mask = this.mask.replace(new RegExp(/[9AS]/), '0');
            } else {
                this.mask = '0*';
            }
            this.patterns = {0: {pattern: this.restrict}};
            this.dropSpecialCharacters = false;
        }
    }

    getClassNames() {
        const cn = this.classNames;
        cn['is-uppercase'] = this.uppercase;
        return cn;
    }

    ngOnDestroy(): any {
        this.subscriptions.unsubscribe();
    }
}
